/**
 * Обьединяет объект RouterPath в строку
 */
export function createPath({ path = '', search = '', hash = '' }) {
    return path + search + hash;
}
/**
 * Парсит строку в обьект RouterPath
 */
export function parsePath(path) {
    const parsed = {};
    let curr = path;
    if (curr) {
        const hashIndex = curr.indexOf('#');
        if (hashIndex >= 0) {
            parsed.hash = curr.substr(hashIndex);
            curr = curr.substr(0, hashIndex);
        }
        const searchIndex = curr.indexOf('?');
        if (searchIndex >= 0) {
            parsed.search = curr.substr(searchIndex);
            curr = curr.substr(0, searchIndex);
        }
        if (curr) {
            parsed.path = curr;
        }
    }
    return parsed;
}
